var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ball-loader flex items-center justify-center relative w-full"},_vm._l((3),function(ball){return _c('div',{key:ball,staticClass:"ball-loader__ball mx-xxs rounded-full w-5 h-5 block relative"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }